import { API_URL, getCachedSessionId } from 'src/services/common';

import { FetchContentsResponseData } from './interfaces/fetchContentsResponseData.interface';
import { api } from '../../../../util/axios-instance';

export const fetchContentsData = async (params: {
  customTypeId: string;
  isHighlighted?: string;
  orderBy: string;
  orderDirection: string;
  page: string;
  pageSize: string;
  projectId: string;
  searchItem: string;
}): Promise<FetchContentsResponseData | undefined> => {
  const {
    projectId,
    page,
    pageSize,
    orderBy,
    orderDirection,
    customTypeId,
    searchItem,
    isHighlighted
  } = params;
  const response = await api.get<FetchContentsResponseData>(
    `${API_URL}/v1/project/${projectId}/content/paginated?limit=${pageSize}&page=${page}&name=${searchItem}&customTypeId=${customTypeId}&orderBy=${orderBy}&orderDirection=${orderDirection}&isHighlighted=${isHighlighted}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
